import { ModalAlertProps, ModalConfirmProps } from '@revenuemarket/ui/types/modal';
import create from 'zustand';

interface ModalSystemAlertProps extends Omit<ModalAlertProps, 'handleClose'> {}
interface ModalSystemConfirmProps extends Omit<ModalConfirmProps, 'handleClose'> {}

interface ModalSystemStore {
  alert: ModalSystemAlertProps;
  confirm: ModalSystemConfirmProps;
  openAlert: (alertProps: Omit<ModalSystemAlertProps, 'isOpen'>) => void;
  openConfirm: (confirmProps: Omit<ModalSystemConfirmProps, 'isOpen'>) => void;
  closeAlert: () => void;
  closeConfirm: () => void;
}

interface InitialState {
  alert: ModalSystemAlertProps;
  confirm: ModalSystemConfirmProps;
}

const initialState: InitialState = {
  alert: {
    isOpen: false,
    title: undefined,
    description: undefined,
  },
  confirm: {
    isOpen: false,
    title: undefined,
    description: undefined,
  },
};

const useModalSystemStore = create<ModalSystemStore>((set) => ({
  ...initialState,
  openAlert: (alertProps) => set(() => ({ alert: { ...alertProps, isOpen: true } })),
  openConfirm: (confirmProps) => set(() => ({ confirm: { ...confirmProps, isOpen: true } })),
  closeAlert: () => set(() => ({ alert: initialState.alert })),
  closeConfirm: () => set(() => ({ confirm: initialState.confirm })),
}));

export default useModalSystemStore;
